var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_3",
    "data-name": "Calque 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.11 191.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e12c42;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.07,194.11a94.17,94.17,0,0,1-67.54-28.26A95.56,95.56,0,0,1,97.07,2.52,94.13,94.13,0,0,1,164.6,30.78,95.56,95.56,0,0,1,97.07,194.11Zm0-182A85.54,85.54,0,0,0,36.24,37.48C2.71,71,2.71,125.61,36.24,159.62a87.08,87.08,0,0,0,60.83,24.91,85.53,85.53,0,0,0,60.83-25.39h0C191.43,125.61,191.43,71,157.9,37A87.14,87.14,0,0,0,97.07,12.1Zm43.58,53.64c-1.91-1.91-4.79-1.44-6.7.48L87,119.87,60.19,93a4.74,4.74,0,0,0-6.71,6.71L84.13,130.4h0c.48.48.48.48,1,.48a.47.47,0,0,1,.48.48c.48,0,1,.48,1.92.48h0a2.86,2.86,0,0,0,1.91-.48l.48-.48c.48,0,.48-.48,1-.48h0l50.29-57.47C142.57,70.53,142.57,67.66,140.65,65.74Z",
    transform: "translate(-1.51 -2.52)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidation);
export default __webpack_public_path__ + "static/media/validation.9822d104.svg";
export { ForwardRef as ReactComponent };